var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 25 25",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65722 21.7519V18.6851C9.6572 17.9051 10.2931 17.2713 11.081 17.2661H13.9671C14.7587 17.2661 15.4005 17.9014 15.4005 18.6851V21.7614C15.4003 22.4237 15.9343 22.9649 16.603 22.9805H18.5271C20.4451 22.9805 22 21.4411 22 19.5423V10.8183C21.9898 10.0713 21.6355 9.36982 21.038 8.9135L14.4577 3.66577C13.3049 2.75204 11.6662 2.75204 10.5134 3.66577L3.96203 8.92303C3.36226 9.37749 3.00739 10.0801 3 10.8278V19.5423C3 21.4411 4.55488 22.9805 6.47291 22.9805H8.39696C9.08235 22.9805 9.63797 22.4304 9.63797 21.7519",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.324b732d565453ed1baea5f6df9ab6dc.svg";
export { ForwardRef as ReactComponent };